<template>
  <div class="main-footer">
    <footer>
      <div class="contact">
        <h3>联系我们</h3>
        <p>重庆孟山信息科技有限公司</p>
        <p>地址：重庆市渝北区海王星科技大厦D区8楼815</p>
        <p>电话：023-67918065</p>
        <p>邮箱：<a href="mailto:contact@mengshankeji.com">contact@mengshankeji.com</a></p>
      </div>
      <div class="copyright">
        &copy;2019 &nbsp; MSKJ.All Rights Reserved 渝ICP备20009974号
      </div>
      <div class="wx">
        <img src="@/images/wx.jpg" title="扫码关注微信公众号">
        <p>扫一扫关注我们</p>
        <p>实时获取最新动态</p>
      </div>
    </footer>
  </div>
</template>

<script>
  export default {
    name: "main-footer"
  }
</script>

<style lang="less">

  footer {
    position: relative;

    .wx {
      position: absolute;
      top: 10px;
      right: 20px;
      text-align: center;
      p{
        margin-top: 2px;
      }
      & > img {
        width: 80px;
        height: 80%;
      }
    }
  }

</style>
